import { createContext, useCallback, useContext, useMemo, useState, type PropsWithChildren } from "react";

const STORAGE_KEY = "ledgerly.activeBook";

function stored(): string {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

interface ActiveBook {
  // Empty means "the book the workspace resolves", which is the default for
  // an owner who never switched books.
  bookID: string;
  setBookID: (value: string) => void;
}

const ActiveBookContext = createContext<ActiveBook>({ bookID: "", setBookID: () => {} });

export function ActiveBookProvider({ children }: PropsWithChildren) {
  const [bookID, setState] = useState(stored);
  const setBookID = useCallback((value: string) => {
    try {
      if (value) window.localStorage.setItem(STORAGE_KEY, value);
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      // A browser without storage still switches for this session.
    }
    setState(value);
  }, []);
  const value = useMemo(() => ({ bookID, setBookID }), [bookID, setBookID]);
  return <ActiveBookContext.Provider value={value}>{children}</ActiveBookContext.Provider>;
}

export function useActiveBook(): ActiveBook {
  return useContext(ActiveBookContext);
}
